import React from 'react'
import { Text } from '@hub/text'
import { ChevronDownMediumIcon, ChevronUpMediumIcon } from '@hub/icon'
import { LinkBox, LinkOverlay } from '@hub/link'
import { Stack } from '@hub/stack'
import { Button } from '@hub/button'
import { Centre as CentreType } from '../../../../types/centre'
interface Centre extends Partial<CentreType> {
  displayTitle?: string
}
interface VisitCentreTabProps {
  suggestedCentres: Centre[]
  isOpenCentre: boolean
  toggleOpenCentre: () => void
}

export const VisitCentreTabPanel: React.FC<VisitCentreTabProps> = ({
  toggleOpenCentre,
  suggestedCentres,
  isOpenCentre,
}) => (
  <Stack direction="row" gap="spacing-xl" shouldWrapChildren={false}>
    <Text>
      <Button
        sx={{
          bg: 'transparent',
          padding: 0,
          margin: 0,
          height: 'none',
          fontWeight: 'normal',
          textTransform: 'none',
          fontSize: 'md',
        }}
        onClick={toggleOpenCentre}
      >
        Find a centre
        {isOpenCentre ? (
          <ChevronUpMediumIcon sx={{ marginLeft: 'spacing-sm' }} />
        ) : (
          <ChevronDownMediumIcon sx={{ marginLeft: 'spacing-sm' }} />
        )}
      </Button>
    </Text>
    {suggestedCentres.length && (
      <Stack direction="row" gap="spacing-md">
        <Text sx={{ color: 'quartz' }}>Suggested centres</Text>
        {suggestedCentres.map(centre => (
          <LinkBox key={centre.slug}>
            <Text>
              <LinkOverlay href={`/${centre.slug}`}>
                {centre.displayTitle}
              </LinkOverlay>
            </Text>
          </LinkBox>
        ))}
      </Stack>
    )}
  </Stack>
)
